import { render, staticRenderFns } from "./NavigationQuickLinks.vue?vue&type=template&id=304b61d8&scoped=true&"
import script from "./NavigationQuickLinks.vue?vue&type=script&lang=ts&"
export * from "./NavigationQuickLinks.vue?vue&type=script&lang=ts&"
import style0 from "./NavigationQuickLinks.vue?vue&type=style&index=0&id=304b61d8&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "304b61d8",
  null
  
)

export default component.exports